import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const FAQS = [{
  q: '¿Qué voy a encontrar en el ebook?',
  a: '9 capítulos breves organizados en 3 partes, cada uno con un ejercicio práctico, más 3 bonos (checklist, diario de 7 días y guion de pausa consciente) para aplicar lo que vas leyendo.'
}, {
  q: '¿Necesito experiencia previa en bienestar o autoayuda?',
  a: 'No. Está escrito en un lenguaje simple y cercano. No necesitás saber nada previo: solo tener ganas de bajar el ritmo y encontrarte de nuevo.'
}, {
  q: '¿Es lo mismo que ir a terapia?',
  a: 'No reemplaza a la terapia. Es una guía práctica de acompañamiento y ejercicios. Si atravesás algo que requiere atención profesional, te recomendamos consultarlo.'
}, {
  q: '¿Cuánto tiempo tengo que dedicarle?',
  a: 'Los capítulos son cortos: podés leer uno en pocos minutos y hacer su ejercicio a tu ritmo. No hay apuro ni fechas límite.'
}, {
  q: '¿En qué formato lo recibo?',
  a: 'En PDF, para leerlo cómodamente en el celular, la tablet o la computadora.'
}, {
  q: '¿Cuándo y cómo recibo el acceso?',
  a: 'El acceso es inmediato. Al confirmar el pago vas a poder descargar el ebook y los bonos al instante.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tenés 7 días de garantía. Si sentís que no es para vos, te devolvemos el 100% de lo que pagaste, sin cuestionarios ni justificaciones.'
}, {
  q: '¿Mis datos y el pago están seguros?',
  a: 'Sí. El pago se procesa de forma segura y tus datos están protegidos durante toda la compra.'
}, {
  q: '¿Tengo que pagar algo más después de comprarlo?',
  a: 'No. Es un pago único, sin suscripciones ni cargos ocultos. El ebook y los bonos son tuyos para siempre.'
}, {
  q: '¿Qué hago si tengo un problema con la descarga o alguna duda?',
  a: 'Escribinos y te ayudamos a resolverlo. Queremos que puedas acceder a tu copia sin complicaciones.'
}];
function FaqItem({
  item,
  isOpen,
  onToggle
}: {
  item: {
    q: string;
    a: string;
  };
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <div className="border-b border-ink/12" data-id="element-28" data-mp="1krt88alk42ep">
      <button onClick={onToggle} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-6 text-left" data-id="element-29" data-mp="1kooyyyt8igh6">
        <span className="font-serif text-xl text-ink" data-id="element-30" data-mp="2df6xdmj0jto9">{item.q}</span>
        <motion.span animate={{
        rotate: isOpen ? 45 : 0
      }} transition={{
        duration: 0.25
      }} className="flex-none text-sage" data-id="element-31" data-mp="28gcfcmsve957">
          <PlusIcon size={22} strokeWidth={1.6} data-id="element-32" data-mp="1zew5qh9vqb21" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-33" data-mp="s2vsae4tihp4">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-34" data-mp="s016oja2iqu4">
            <p className="pb-6 pr-10 font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-35" data-mp="3dgkfdtzmxb7r">
              {item.a}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-sage-band py-20 md:py-28" data-id="element-36" data-mp="3rf1zlhqc05kx">
      <div className="mx-auto max-w-3xl px-6" data-id="element-37" data-mp="3rdh51s40omn2">
        <SectionHeading eyebrow="Preguntas frecuentes" title="Todo lo que quieras saber" data-id="element-38" data-mp="7xtqq5xape3" />
        <div className="mt-12" data-id="element-39" data-mp="1x2tx9jbokmf4">
          {FAQS.map((item, i) => <FaqItem key={i} item={item} isOpen={open === i} onToggle={() => setOpen(open === i ? null : i)} data-id="element-40" data-mp="21zke48vb7m1l" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}